import React from 'react'
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom'
import ScrollToTop from './components/ScrollToTop'
import HomePage from './pages/HomePage'
import HomePageEn from './pages/HomePage en'
import About from './pages/About'
import AboutEn from './pages/About en'
import ConsultationBooking from './pages/ConsultationBooking'
import FAQ from './pages/FAQ'
import Testimonials from './pages/Testimonials'
import Blog from './pages/Blog'
import Packages from './pages/Packages'

import CommercialCases from './pages/CommercialCases'
import LegalConsultation from './pages/LegalConsultation'
import JudicialRepresentation from './pages/JudicialRepresentation'
import ContractDrafting from './pages/ContractDrafting'
import WealthDistribution from './pages/WealthDistribution'
import FamilyLaw from './pages/FamilyLaw'
import GeneralCourts from './pages/GeneralCourts'
import Corporates from './pages/Corporates'
import RealEstate from './pages/RealEstate'
import WorkAndLabor from './pages/WorkAndLabor'
import IntellectualProperty from './pages/IntellectualProperty'
import AlternativeDisputeResolution from './pages/AlternativeDisputeResolution'

import DebtCollection from './pages/DebtCollection'
import NotarizationServices from './pages/NotarizationServices'
import ForeignInvestment from './pages/ForeignInvestment'
import InsuranceDisputes from './pages/InsuranceDisputes'

import WorkRegulations from './pages/WorkRegulations'
import Ecommerce from './pages/Ecommerce'
import CooperativeTraining from './pages/CooperativeTraining'
import OfficialAccreditations from './pages/OfficialAccreditations'
import Services from './pages/Services'
import Blog1 from './pages/Blog1'
import Blog2 from './pages/Blog2'
import Blog3 from './pages/Blog3'
import Blog4 from './pages/Blog4'
import Blog5 from './pages/Blog5'
import BlogPost6 from './pages/Blog6'
import Careers from './pages/Careers'

function App() {
  return (
    <Router>
      <ScrollToTop />
      <div className="min-h-screen" dir="rtl">
        <Routes>
          <Route path="/" element={<HomePage />} />
          <Route path="/HomePage" element={<HomePage />} />
          <Route path="/HomePage-en" element={<HomePageEn />} />
          <Route path="/about" element={<About />} />
          <Route path="/about-en" element={<AboutEn />} />
          <Route path="/consultation" element={<ConsultationBooking />} />
          <Route path="/ConsultationBooking" element={<ConsultationBooking />} />
          <Route path="/faq" element={<FAQ />} />
          <Route path="/testimonials" element={<Testimonials />} />
          <Route path="/blog" element={<Blog />} />
          <Route path="/Blog" element={<Blog />} />
          <Route path="/packages" element={<Packages />} />

          <Route path="/commercial-cases" element={<CommercialCases />} />
          <Route path="/CommercialCases" element={<CommercialCases />} />
          <Route path="/legal-consultation" element={<LegalConsultation />} />
          <Route path="/LegalConsultation" element={<LegalConsultation />} />
          <Route path="/judicial-representation" element={<JudicialRepresentation />} />
          <Route path="/JudicialRepresentation" element={<JudicialRepresentation />} />
          <Route path="/contract-drafting" element={<ContractDrafting />} />
          <Route path="/ContractDrafting" element={<ContractDrafting />} />
          <Route path="/wealth-distribution" element={<WealthDistribution />} />
          <Route path="/WealthDistribution" element={<WealthDistribution />} />
          <Route path="/family-law" element={<FamilyLaw />} />
          <Route path="/FamilyLaw" element={<FamilyLaw />} />
          <Route path="/general-courts" element={<GeneralCourts />} />
          <Route path="/GeneralCourts" element={<GeneralCourts />} />
          <Route path="/corporates" element={<Corporates />} />
          <Route path="/Corporates" element={<Corporates />} />
          <Route path="/real-estate" element={<RealEstate />} />
          <Route path="/RealEstate" element={<RealEstate />} />
          <Route path="/work-and-labor" element={<WorkAndLabor />} />
          <Route path="/WorkAndLabor" element={<WorkAndLabor />} />
          <Route path="/intellectual-property" element={<IntellectualProperty />} />
          <Route path="/IntellectualProperty" element={<IntellectualProperty />} />
          <Route path="/alternative-dispute-resolution" element={<AlternativeDisputeResolution />} />
          <Route path="/AlternativeDisputeResolution" element={<AlternativeDisputeResolution />} />

          <Route path="/debt-collection" element={<DebtCollection />} />
          <Route path="/DebtCollection" element={<DebtCollection />} />
          <Route path="/تحصيل-الديون" element={<DebtCollection />} />
          <Route path="/information-security" element={<Navigate to="/debt-collection" replace />} />
                  <Route path="/InformationSecurity" element={<Navigate to="/debt-collection" replace />} />
        <Route path="/mining" element={<Navigate to="/notarization-services" replace />} />
        <Route path="/Mining" element={<Navigate to="/notarization-services" replace />} />
        <Route path="/notarization-services" element={<NotarizationServices />} />
        <Route path="/NotarizationServices" element={<NotarizationServices />} />
          <Route path="/foreign-investment" element={<ForeignInvestment />} />
          <Route path="/ForeignInvestment" element={<ForeignInvestment />} />
          <Route path="/personal-status" element={<Navigate to="/insurance-disputes" replace />} />
          <Route path="/PersonalStatus" element={<Navigate to="/insurance-disputes" replace />} />
          <Route path="/insurance-disputes" element={<InsuranceDisputes />} />
          <Route path="/InsuranceDisputes" element={<InsuranceDisputes />} />
          <Route path="/work-regulations" element={<WorkRegulations />} />
          <Route path="/WorkRegulations" element={<WorkRegulations />} />
          <Route path="/ecommerce" element={<Ecommerce />} />
          <Route path="/Ecommerce" element={<Ecommerce />} />
          <Route path="/arbitration" element={<Navigate to="/work-regulations" replace />} />
          <Route path="/Arbitration" element={<Navigate to="/work-regulations" replace />} />
          <Route path="/cooperative-training" element={<CooperativeTraining />} />
          <Route path="/CooperativeTraining" element={<CooperativeTraining />} />
          <Route path="/official-accreditations" element={<OfficialAccreditations />} />
          <Route path="/OfficialAccreditations" element={<OfficialAccreditations />} />
          <Route path="/services" element={<Services />} />
          <Route path="/Services" element={<Services />} />
          <Route path="/blog1" element={<Blog1 />} />
          <Route path="/blog2" element={<Blog2 />} />
          <Route path="/blog3" element={<Blog3 />} />
          <Route path="/blog4" element={<Blog4 />} />
          <Route path="/blog5" element={<Blog5 />} />
          <Route path="/Blog5" element={<Blog5 />} />
          <Route path="/blog6" element={<BlogPost6 />} />
          <Route path="/Blog6" element={<BlogPost6 />} />
          <Route path="/careers" element={<Careers />} />
          <Route path="/Careers" element={<Careers />} />
        </Routes>
      </div>
    </Router>
  )
}

export default App 